import { createFeatureSelector } from '@ngrx/store';
import { createApiCallSelectors } from 'src/app/common/store/generic.selectors';
import { IContractState } from './contract.reducer';
import {
  ContractStatus,
  contractFeatureKey,
  ContractStatusHistoryModel,
  CreateContractFormModel,
  ContractHealthFormModel,
  ContractCarFormModel,
  ContractHouseFormModel,
  ContractHealthUpdateModel,
  ContractHouseUpdateModel,
  ContractCarUpdateModel,
  ContractAddBaseModel,
  ContractUpdateBaseModel,
  ContractModel,
  ContractRejectReasonModel,
  ContractTerminationReasonModel,
} from './types';

const contractFeatureState =
  createFeatureSelector<IContractState>(contractFeatureKey);

export const contractSelectors = {
  getById: createApiCallSelectors<string, IContractState>(
    contractFeatureState,
    'getById',
  ),

  getByUniqueId: createApiCallSelectors<string, IContractState>(
    contractFeatureState,
    'getByUniqueId',
  ),

  getByLeadId: createApiCallSelectors<string, IContractState>(
    contractFeatureState,
    'getByLeadId',
  ),

  getHealthDetail: createApiCallSelectors<number, IContractState>(
    contractFeatureState,
    'getHealthDetail',
  ),
  getCarDetail: createApiCallSelectors<number, IContractState>(
    contractFeatureState,
    'getCarDetail',
  ),
  getHouseDetail: createApiCallSelectors<number, IContractState>(
    contractFeatureState,
    'getHouseDetail',
  ),

  getStatusFlow: createApiCallSelectors<ContractStatus, IContractState>(
    contractFeatureState,
    'getStatusFlow',
  ),

  getStatusActions: createApiCallSelectors<ContractStatus, IContractState>(
    contractFeatureState,
    'getStatusActions',
  ),
  confirm: createApiCallSelectors<number, IContractState>(
    contractFeatureState,
    'confirm',
  ),
  saveAsDraft: createApiCallSelectors<number, IContractState>(
    contractFeatureState,
    'saveAsDraft',
  ),
  requestValidation: createApiCallSelectors<number, IContractState>(
    contractFeatureState,
    'requestValidation',
  ),
  validate: createApiCallSelectors<number, IContractState>(
    contractFeatureState,
    'validate',
  ),
  reject: createApiCallSelectors<ContractRejectReasonModel, IContractState>(
    contractFeatureState,
    'reject',
  ),
  verify: createApiCallSelectors<number, IContractState>(
    contractFeatureState,
    'verify',
  ),
  suspendContract: createApiCallSelectors<number, IContractState>(
    contractFeatureState,
    'suspendContract',
  ),
  closeContract: createApiCallSelectors<
    ContractTerminationReasonModel,
    IContractState
  >(contractFeatureState, 'closeContract'),
  reopenContract: createApiCallSelectors<number, IContractState>(
    contractFeatureState,
    'reopenContract',
  ),
  getContractModel: createApiCallSelectors<ContractModel, IContractState>(
    contractFeatureState,
    'getContractModel',
  ),
  getHealthContractModel: createApiCallSelectors<number, IContractState>(
    contractFeatureState,
    'getHealthContractModel',
  ),
  getCarContractModel: createApiCallSelectors<number, IContractState>(
    contractFeatureState,
    'getCarContractModel',
  ),
  getHouseContractModel: createApiCallSelectors<number, IContractState>(
    contractFeatureState,
    'getHouseContractModel',
  ),

  createContract: createApiCallSelectors<ContractAddBaseModel, IContractState>(
    contractFeatureState,
    'createContract',
  ),

  createHealthContract: createApiCallSelectors<
    ContractHealthFormModel,
    IContractState
  >(contractFeatureState, 'createHealthContract'),

  createCarContract: createApiCallSelectors<
    ContractCarFormModel,
    IContractState
  >(contractFeatureState, 'createCarContract'),

  createHouseContract: createApiCallSelectors<
    ContractHouseFormModel,
    IContractState
  >(contractFeatureState, 'createHouseContract'),

  updateContract: createApiCallSelectors<
    ContractUpdateBaseModel,
    IContractState
  >(contractFeatureState, 'updateContract'),

  updateHealthContract: createApiCallSelectors<
    ContractHealthUpdateModel,
    IContractState
  >(contractFeatureState, 'updateHealthContract'),

  updateCarContract: createApiCallSelectors<
    ContractCarUpdateModel,
    IContractState
  >(contractFeatureState, 'updateCarContract'),

  updateHouseContract: createApiCallSelectors<
    ContractHouseUpdateModel,
    IContractState
  >(contractFeatureState, 'updateHouseContract'),
  getIfDataReadOnlyFromContractId: createApiCallSelectors<
    boolean,
    IContractState
  >(contractFeatureState, 'getIfDataReadOnlyFromContractId'),
  getContractStatusHistory: createApiCallSelectors<
    ContractStatusHistoryModel,
    IContractState
  >(contractFeatureState, 'getContractStatusHistory'),
  updateContractStatusHistory: createApiCallSelectors<
    ContractStatusHistoryModel,
    IContractState
  >(contractFeatureState, 'updateContractStatusHistory'),
  deleteContractStatusHistory: createApiCallSelectors<boolean, IContractState>(
    contractFeatureState,
    'deleteContractStatusHistory',
  ),
};
